// extracted by mini-css-extract-plugin
export default {"zoomModal":"u0-z","image":"v0-z","button":"w0-z","isOverlayShown":"x0-z"};